import { RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCatalogRadioGroup = styled(RadioGroup)(({ theme }) => ({
  flexShrink: 0,
  gap: theme.new.spacing.medium,
  display: 'flex',
  '& .MuiFormControlLabel-root': {
    marginRight: 0,
    color: theme.palette.text.primary,
    '&.Mui-disabled': {
      color: theme.palette.text.disabled,
    },
    '& .MuiRadio-root': {
      '& svg': {
        width: '16px',
        height: '16px',
      },
      '&.Mui-checked svg path': {
        fill: theme.new.color.brandPrimary,
      },
      '&.Mui-disabled svg path': {
        fill: theme.new.color.line.border,
      },
    },
  },
}));

export default StyledCatalogRadioGroup;
